import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login/index.vue";
import { getToken } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      title: "登录",
      needLogin: false,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../views/Register/index.vue"),
    meta: {
      title: "注册",
      needLogin: false,
    },
  },
  {
    path: "/single-register",
    name: "SingleRegister",
    component: () =>
      import(/* webpackChunkName: "SingleRegister" */ "../views/SingleRegister/index.vue"),
    meta: {
      title: "单独注册",
      needLogin: false,
    },
  },
  {
    path: "/forget",
    name: "ForgetPassword",
    component: () =>
      import(/* webpackChunkName: "ForgetPassword" */ "../views/ForgetPassword/index.vue"),
    meta: {
      title: "注册",
      needLogin: false,
    },
  },
  {
    path: "/workbench",
    name: "Workbench",
    component: () =>
      import(
        /* webpackChunkName: "WorkbenchLayout" */ "../layout/workbench/index.vue"
      ),
    meta: {
      title: "首页",
      needLogin: true,
    },
    children: [
      {
        path: "",
        name: "WorkbenchHome",
        component: () =>
          import(
            /* webpackChunkName: "Workbench" */ "../views/Workbench/index.vue"
          ),
        meta: {
          nav: "workbench",
          title: "首页",
          needLogin: true,
        },
        children: [
          {
            path: "role",
            name: "WorkbenchRole",
            component: () =>
              import(
                /* webpackChunkName: "WorkbenchRole" */ "../views/Workbench/role/index.vue"
              ),
            meta: {
              nav: "workbench",
              title: "角色",
              needLogin: true,
            },
          },
          {
            path: "bind",
            name: "WorkbenchBind",
            component: () =>
              import(
                /* webpackChunkName: "WorkbenchBind" */ "../views/Workbench/bind/index.vue"
              ),
            meta: {
              nav: "workbench",
              title: "绑定",
              needLogin: true,
            },
          },
          {
            path: "bind-admin",
            name: "WorkbenchBindAdmin",
            component: () =>
              import(
                /* webpackChunkName: "WorkbenchBindAdmin" */ "../views/Workbench/bindAdmin/index.vue"
              ),
            meta: {
              nav: "workbench",
              title: "绑定管理员",
              needLogin: true,
            },
          },
        ],
      },
      {
        path: "change-info",
        name: "WorkbenchChangeInfo",
        component: () =>
          import(
            /* webpackChunkName: "ChangeInfo" */ "../views/ChangeInfo/index.vue"
          ),
        meta: {
          nav: "change-info",
          title: "修改信息",
          needLogin: true,
        },
      },
      {
        path: "change-pwd",
        name: "WorkbenchChangePassword",
        component: () =>
          import(
            /* webpackChunkName: "ChangePassword" */ "../views/ChangePassword/index.vue"
          ),
        meta: {
          nav: "change-pwd",
          title: "修改密码",
          needLogin: true,
        },
      },
      {
        path: "unbund",
        name: "WorkbenchUnbund",
        component: () =>
          import(/* webpackChunkName: "Unbund" */ "../views/Unbund/index.vue"),
        meta: {
          nav: "unbund",
          title: "解绑",
          needLogin: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach((to, from, next) => {
  let token = getToken();
  console.log(token,'beforeEach');
  const { meta, query } = to;
  if (meta.title) {
    document.title = meta.title;
  }
  // console.log(meta, "meta", token);
  if (meta.needLogin) {
    if (!token) {
      next({
        name: "Login",
        query,
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
